import { navigate } from "../../../libraries/universal-route/router";
import { get } from "../../../components/api";

const listUrlOrderby = (modifiers) =>
  !modifiers.orderby || !modifiers.orderby.field
    ? "_"
    : `${modifiers.orderby.field}-${modifiers.orderby.direction}`;

const listUrlSearch = (modifiers) =>
  !modifiers.search ? "_" : modifiers.search;

const listUrlFilter = (modifiers) =>
  !modifiers.filters || modifiers.filters.length == 0
    ? "_"
    : JSON.stringify(modifiers.filters);

export const updateListUrlMerge = (modifiers, update = {}) => {
  if (
    update?.sectionModifiers?.filters &&
    modifiers?.sectionModifiers?.filters
  ) {
    update.sectionModifiers.filters = Object.assign(
      {},
      modifiers.sectionModifiers.filters,
      update.sectionModifiers.filters
    );
  }
  if (update?.filters && modifiers?.filters) {
    update.filters = Object.assign({}, modifiers.filters, update.filters);
  }
  return Object.assign({}, modifiers, update);
};

export const getEntityBaseUrl = (baseUrl, modifiers) => {
  if (baseUrl[0] != "/") baseUrl = `/${baseUrl}`;

  const pieces = baseUrl.split("/");
  if (pieces.length < 2) return "#";

  const topSection = `/${pieces[1]}/${pieces[2]}/${modifiers["limit"]}/${
    modifiers["page"]
  }/${listUrlOrderby(modifiers)}/${listUrlSearch(modifiers)}/${listUrlFilter(
    modifiers
  )}/${modifiers.id ? modifiers.id : "_"}`;

  let bottomSection = "";
  if (modifiers.section) {
    bottomSection += `/${modifiers.section}/${
      modifiers.sectionId ? modifiers.sectionId : "_"
    }`;
    if (modifiers["sectionModifiers"].limit) {
      bottomSection += `/${modifiers["sectionModifiers"].limit}`;
    } else {
      bottomSection += `/100`;
    }
    if (modifiers["sectionModifiers"] && modifiers["sectionModifiers"].page) {
      bottomSection += `/${modifiers["sectionModifiers"].page}`;
    } else {
      bottomSection += `/1`;
    }
    bottomSection += `/${listUrlOrderby(modifiers["sectionModifiers"])}`;
    bottomSection += `/${listUrlSearch(modifiers["sectionModifiers"])}`;
    bottomSection += `/${listUrlFilter(modifiers["sectionModifiers"])}`;
  }
  return `${topSection}${bottomSection}`;
};

export const getEntitySectionUrl = (baseUrl, modifiers) => {
  const { id, section, sectionId, limit, page } = modifiers;
  return `${baseUrl}/${limit}/${page}/${listUrlOrderby(
    modifiers
  )}/${listUrlSearch(modifiers)}/${listUrlFilter(modifiers)}${
    id ? `/${id}` : ""
  }${section ? `/${section}` : ""}${sectionId ? `/${sectionId}` : "_"}`;
};

export const updatedUrl = (baseUrl, modifiers, update = {}) =>
  getEntityBaseUrl(baseUrl, updateListUrlMerge(modifiers, update));

export const updateListUrl = (baseUrl, modifiers, update = {}) => {
  navigate(updatedUrl(baseUrl, modifiers, update));
};

export const checkIsSorting = (context, key) =>
  !context.sortState ? false : !context.sortState[key] ? false : true;

export const makeOpenCheck = (entity, id, data) => {
  if (!data) return `${entity}__${id}`;
  return `${entity}__${id}__${JSON.stringify(data)}`;
};

export const formVisibilityWithToggle = (entity, id, setOpen) => ({
  open: setOpen(`CHECK:${makeOpenCheck(entity, id)}`),
  setOpen: (modalId, changeContentUrl, changeLocationUrl) => {
    return setOpen(
      modalId ? modalId : makeOpenCheck(entity, id),
      changeContentUrl,
      changeLocationUrl
    );
  }
});

export const checkModalOpen = (modalKey, entity, id) => {
  const checkKey = `${makeOpenCheck(entity, id)}`;
  return checkKey in modalKey && modalKey[checkKey] === true ? true : false;
};

export const setOpenFactory =
  (dispatch, modalKey, only = false) =>
  (modalId, changeContentUrl, changeLocationUrl) => {
    if (modalId.substr(0, 6) === "CHECK:") {
      const checkKey = modalId.substr(6);
      const result =
        checkKey in modalKey && modalKey[checkKey] === true ? true : false;
      return result;
    }
    dispatch({
      type: only === true ? "TOGGLE_MODAL_ONLY" : "TOGGLE_MODAL",
      data: {
        id: modalId,
        value: modalKey === undefined ? true : !modalKey[modalId]
      }
    });
    if (changeContentUrl && typeof changeContentUrl === "string") {
      get(changeContentUrl, {}).then(({ data }) => {
        dispatch({ type: "CHANGE_CONTENT", data });
      });
    }
    if (changeLocationUrl && typeof changeLocationUrl === "string") {
      navigate(changeLocationUrl);
    }
  };

export const isNumeric = (value) => /^\d+$/.test(value);

export const parseModalKey = (modalKey) => {
  const modalKeys = Object.keys(modalKey);
  if (modalKeys.filter((key) => modalKey[key] === true).length === 0)
    return [null, false, 0];
  const key = modalKeys[0];
  const [before, after, last] = key.split("__", 3);
  let data = null;
  if (last) {
    const prefixLength = `${before}__${after}__`.length;
    data = key.substring(prefixLength);
  }

  if (after === "new") return [before, true, 0, last ? JSON.parse(data) : null];
  return [
    before,
    false,
    isNumeric(after) ? parseInt(after) : after,
    last ? JSON.parse(data) : null
  ];
};
